<template>
  <div class=" ">
    <v-layout>
      <v-flex>
        <section>
          <v-card flat style="height: 100vh;">
            <v-card-text style="height: 100%;">

              <v-row style="height: 100%; margin: 0; padding: 0;">
                <v-col 
                  cols="12"
                  md="5"
                  class="py-0">
                  <v-card class="" flat style="background: #3f9481; border-radius: 16px;" height="100%">
                    <v-card-text class="pa-10" style="height: 100%;">
                      <div>
                        <div>
                          <div class="mb-12">
                            <!-- <v-img
                              src="@/assets/logo/Logo.png"
                              contain
                              style="width: 273px; height: 40px;">
                            </v-img> -->
                          </div>
                          <div>
                            <div class="fs-32 white--text font-weight-bold mb-6">
                              Sifasum
                            </div>
                            <div class="fs-15 white--text">
                              Dinas Perumahan Rakyat dan Kawasan Permukiman Kabupaten Klaten
                            </div>
                          </div>
                        </div>
                        <div class="mt-8 pt-1">
                          <v-img
                            src="@/assets/image/gedung.png"
                            width="`80%"
                            cover>
                          </v-img>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col 
                  cols="12"
                  md="7"
                  class="pa-0"
                  style="height: 100%; display: flex; align-items: center; justify-content: center;">
                  <v-card
                    flat
                    style="width: 500px;">
                    <div>
                      <v-card
                        flat
                        color="#FFFFFFB2"
                        class="border-radius">
                        <v-card-text
                          class="pa-0">
                          <div
                            class="mb-6">
                            <div
                              class="fs-30 black_one font-weight-bold black--text mb-12">
                              Masuk
                            </div>
                          </div>
    
                          <ValidationObserver 
                            ref="observer">
                            <v-form class="text-left mb-0">
                              <div class="fs-14 mb-1 black_two">
                                Email
                              </div>
                              <ValidationProvider 
                                name="Email" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Masukan email yang telah didaftarkan"
    
                                  vv-uppercase
    
                                  v-model="form.username"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
    
                              <div class="fs-14 mb-1 black_two">
                                Kata Sandi
                              </div>
                              <ValidationProvider 
                                name="password" 
                                rules="required|min:5|max:30" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="set_color"
                                  style="border-radius: 4px;"
                                  placeholder="Masukan kata sandi"
                                  :type="show ? 'text' : 'password'"
                                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                  @click:append="show = !show"
                                  :counter="30"
    
                                  vv-uppercase
                                  
                                  v-model="form.password"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
                            </v-form>
                          </ValidationObserver>
    
                          <div 
                            class="text-center mb-6">
                            <div v-if="message.error.length > 0"
                              class="text-center my-4">
                              <div
                                class="error--text d-flex align-start">
                                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.error }}
                                </span>
                              </div>
                            </div>
    
                            <!-- <div class="blue_one fs-14 text-right mt-1 mb-5" style="font-weight: 600;">
                              <span class="cursor-pointer">Lupa Kata Sandi</span>
                            </div> -->
    
                            <v-btn
                              :disabled="process.form"
                              :loading="process.form"
                              @click="save()"
                              block
                              color="#3f9481"
                              width="170"
                              height="40"
                              elevation="0"
                              class="title font-weight-bold white--text text-capitalize border-radius">
                              Masuk
                            </v-btn>
    
                            <!-- <div class="text-center fs-14 my-10">
                              <span class="black_two">Belum punya akun? </span>
                              <span class="blue_one cursor-pointer" @click="toRegister()">Daftar</span>
                            </div> -->
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data)
              let user = res.results.data,
                  // menu_arr = res.results.data.cat_menu_array.length < 1 ? [] : res.results.data.cat_menu_array,
                  menu_default = [
                    {
                      "id": 1,
                      "name": "Dashboard",
                      "icon": "mdi-view-dashboard",
                      "url": "/dashboard",
                      "sub_menu": []
                    },
                    {
                      "id": 2,
                      "name": "Master",
                      "icon": "mdi-account-group",
                      "url": "/master",
                      "sub_menu": []
                    },
                    {
                      "id": 3,
                      "name": "Transaksi",
                      "icon": "mdi-cash",
                      "url": "/transaksi",
                      "sub_menu": []
                    },
                    {
                      "id": 4,
                      "name": "Laporan",
                      "icon": "mdi-file-document",
                      "url": "/laporan",
                      "sub_menu": []
                    },
                    {
                      "id": 5,
                      "name": "Pengaturan",
                      "icon": "mdi-cog",
                      "url": "/pengaturan",
                      "sub_menu": []
                    }
                  ]
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_default)
              )

              TokenService.saveReload(false)

              TokenService.saveColor(
                '#080679'
              )

              this.$store.commit("setColor", '#080679')

              window.location = `${process.env.BASE_URL}`
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>